import { render, staticRenderFns } from "./form-organizations-users-notifications.vue?vue&type=template&id=75cd024c&scoped=true&lang=pug"
import script from "./form-organizations-users-notifications.vue?vue&type=script&lang=js"
export * from "./form-organizations-users-notifications.vue?vue&type=script&lang=js"
import style0 from "./form-organizations-users-notifications.vue?vue&type=style&index=0&id=75cd024c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75cd024c",
  null
  
)

export default component.exports